import { useState } from "react";

import Animation3D from "../assets/skills/3DAnimation.png";
import AdvanceTransition from "../assets/skills/AdvanceTransition.png";
import CameraAnimation from "../assets/skills/CameraAnimation.png";
import ColoreGrading from "../assets/skills/ColoreGrading.png";
import GreenScreen from "../assets/skills/GreenScreen.png";
import LowerThirds from "../assets/skills/LowerThirds.png";
import RotoScoping from "../assets/skills/RotoScoping.png";
import SharpCropping from "../assets/skills/SharpCropping.png";
import SoundDesign from "../assets/skills/SoundDesign.png";
import Typography from "../assets/skills/Typography.png";
import VisualEffect from "../assets/skills/VisualEffect.png";

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const SKILLS = [
  {
    name: "Green Screen",
    image: GreenScreen,
  },
  {
    name: "Color Grading/Color Correction.",
    image: ColoreGrading,
  },
  {
    name: "Typography",
    image: Typography,
  },
  {
    name: "Animation",
    image: Animation3D,
  },
  {
    name: "Transition",
    image: AdvanceTransition,
  },
  {
    name: "Lower Thirds",
    image: LowerThirds,
  },
  {
    name: "Visual Effects",
    image: VisualEffect,
  },
  {
    name: "Cropping",
    image: SharpCropping,
  },
  {
    name: "Roto-scoping",
    image: RotoScoping,
  },
  {
    name: "Sound Effect",
    image: SoundDesign,
  },
  {
    name: "Camera Animation",
    image: CameraAnimation,
  },
];

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 3,
    },
    desktop: {
      breakpoint: { max: 2000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <section className="skillClass" id="skills">
      <div className="row">
        <div>
          <div className="skill-bx wow zoomIn">
            <h2>Skills</h2>
            {/* <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry.<br></br> Lorem Ipsum has been the industry's standard
                dummy text.
              </p> */}
            <Carousel
              responsive={responsive}
              infinite={true}
              customLeftArrow={<CustomLeftArrow />}
              customRightArrow={<CustomRightArrow />}
              className="owl-carousel owl-theme skill-slider"
            >
              {SKILLS.map((item, index) => {
                return (
                  <div className="item">
                    <img
                      src={item.image}
                      alt={item.name}
                      style={{
                        boxShadow: "7px 7px 12px rgba(255, 255, 255, 0.2)",
                      }}
                    />
                    <h5>{item.name}</h5>
                  </div>
                );
              })}
            </Carousel>
          </div>
        </div>
      </div>
    </section>
  );
};

const CustomLeftArrow = ({ onClick }) => {
  const [hover, setHover] = useState(false);
  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        position: "absolute",
        left: -2,
        // top: "50%",
        width: 50,
        height: 50,
        transform: "translateY(-50%)",
        zIndex: 100,
        cursor: "pointer",
        backgroundColor: hover ? "#00000099" : "#00000099",
        borderRadius: "50%",
        // boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
        transition: "0.3s",
        boxShadow: hover ? " 2px 1px 5px rgba(255, 255, 255, 0.6)" : "",
        alignItems: "center",
        justifyContent: "center",
        display: "flex",
      }}
    >
      <span style={{ color: "#fff", fontSize: 30 }}>‹</span>
    </div>
  );
};

// Usama
const CustomRightArrow = ({ onClick }) => {
  const [hover, setHover] = useState(false);
  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        position: "absolute",
        right: -2,
        // top: "50%",
        width: 50,
        height: 50,
        transform: "translateY(-50%)",
        zIndex: 2,
        cursor: "pointer",
        backgroundColor: hover ? "#00000099" : "#00000099",
        borderRadius: "50%",
        // boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
        transition: "0.3s",
        boxShadow: hover ? " 2px 1px 5px rgba(255, 255, 255, 0.6)" : "",
        alignItems: "center",
        justifyContent: "center",
        display: "flex",
      }}
    >
      <span style={{ color: "#fff", fontSize: 30 }}>›</span>
    </div>
  );
};
